import { GridLoader } from 'react-spinners';
import { useTheme } from '@lok/context/ThemeContext';

const GlobalLoader = () => {
  const theme = useTheme();

  return (
    <div className='flex items-center justify-center h-screen m-auto'>
      <GridLoader
        color={theme.isDarkMode ? '#ffffff' : '#000000'}
        size={15}
      />
    </div>
  );
};
export default GlobalLoader;
